export default __webpack_public_path__ + "static/media/detroitLionsVideo-2x.50d4f713.jpg";